import * as React from "react";

function PersonDressIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M160 96c26.5 0 48-21.5 48-48S186.5 0 160.9 0c-26.5 0-48 21.5-48 48s20.6 48 47.1 48zm148.7 179.8-61.44-104.5C231.5 144.6 202.4 128 171.4 128h-22.8c-31 0-60.1 16.6-75.85 43.4L11.32 275.8c-6.722 11.5-2.91 25.3 8.53 32.9 3.81 2.2 7.99 3.3 12.11 3.3 8.221 0 16.23-4.234 20.72-11.83l53.67-91.25L47.1 384H96v104c0 13.25 10.74 24 23.1 24s24.9-10.7 24.9-24V384h32v104c0 13.25 10.74 24 24 24s24-10.7 24-24V384h48l-58.36-175.1 53.67 91.25C271.8 307.8 279.8 312 288 312c4.125 0 8.312-1.062 12.12-3.312C311.6 301.1 315.4 287.3 308.7 275.8zM114.6 336 160 199.8 205.4 336h-90.8z"
  }));
}

const ForwardRef = React.forwardRef(PersonDressIcon);
export default ForwardRef;